import { useState, useEffect } from "react";
import img from "../../assets/images/home/Mask Group 14.png";

const Comments = () => {
  return (
    <div
      className="border item shadow-sm p-3 position-relative col-3"
      style={{ marginTop: "35px" }}
    >
      <img
        src={img}
        className="position-absolute"
        style={{ top: "-35px", left: "6px", width: "80px" }}
        alt
      />
      <div className="d-flex flex-row" style={{ marginTop: "30px" }}>
        <p
          className="mb-1 fs-6"
          style={{ height: "fit-content", color: "#203B8C" }}
        >
          <strong>مسعود میرزایی</strong>
        </p>
        <div
          className="d-flex flex-row justify-content-between w-50 mx-4 my-auto"
          style={{ height: "fit-content" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={10}
            height={10}
            viewBox="0 0 10 10"
          >
            <path
              id="Icon_awesome-star"
              data-name="Icon awesome-star"
              d="M5.9.347,4.684,2.933l-2.731.416a.633.633,0,0,0-.331,1.066L3.6,6.426,3.131,9.268A.6.6,0,0,0,4,9.926L6.441,8.584,8.884,9.926a.6.6,0,0,0,.867-.658L9.284,6.426,11.26,4.415a.633.633,0,0,0-.331-1.066L8.2,2.933,6.978.347A.588.588,0,0,0,5.9.347Z"
              transform="translate(-1.441 0.001)"
              fill="#f2bf27"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={10}
            height={10}
            viewBox="0 0 10 10"
          >
            <path
              id="Icon_awesome-star"
              data-name="Icon awesome-star"
              d="M5.9.347,4.684,2.933l-2.731.416a.633.633,0,0,0-.331,1.066L3.6,6.426,3.131,9.268A.6.6,0,0,0,4,9.926L6.441,8.584,8.884,9.926a.6.6,0,0,0,.867-.658L9.284,6.426,11.26,4.415a.633.633,0,0,0-.331-1.066L8.2,2.933,6.978.347A.588.588,0,0,0,5.9.347Z"
              transform="translate(-1.441 0.001)"
              fill="#f2bf27"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={10}
            height={10}
            viewBox="0 0 10 10"
          >
            <path
              id="Icon_awesome-star"
              data-name="Icon awesome-star"
              d="M5.9.347,4.684,2.933l-2.731.416a.633.633,0,0,0-.331,1.066L3.6,6.426,3.131,9.268A.6.6,0,0,0,4,9.926L6.441,8.584,8.884,9.926a.6.6,0,0,0,.867-.658L9.284,6.426,11.26,4.415a.633.633,0,0,0-.331-1.066L8.2,2.933,6.978.347A.588.588,0,0,0,5.9.347Z"
              transform="translate(-1.441 0.001)"
              fill="#f2bf27"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={10}
            height={10}
            viewBox="0 0 10 10"
          >
            <path
              id="Icon_awesome-star"
              data-name="Icon awesome-star"
              d="M5.9.347,4.684,2.933l-2.731.416a.633.633,0,0,0-.331,1.066L3.6,6.426,3.131,9.268A.6.6,0,0,0,4,9.926L6.441,8.584,8.884,9.926a.6.6,0,0,0,.867-.658L9.284,6.426,11.26,4.415a.633.633,0,0,0-.331-1.066L8.2,2.933,6.978.347A.588.588,0,0,0,5.9.347Z"
              transform="translate(-1.441 0.001)"
              fill="#f2bf27"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={10}
            height={10}
            viewBox="0 0 10 10"
          >
            <path
              id="Icon_awesome-star"
              data-name="Icon awesome-star"
              d="M5.9.347,4.684,2.933l-2.731.416a.633.633,0,0,0-.331,1.066L3.6,6.426,3.131,9.268A.6.6,0,0,0,4,9.926L6.441,8.584,8.884,9.926a.6.6,0,0,0,.867-.658L9.284,6.426,11.26,4.415a.633.633,0,0,0-.331-1.066L8.2,2.933,6.978.347A.588.588,0,0,0,5.9.347Z"
              transform="translate(-1.441 0.001)"
              fill="#f2bf27"
            />
          </svg>
        </div>
      </div>
      <div className="p-4">
        <div className="main-text">
          <p className="text-color text-center" style={{ fontSize: 14 }}>
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز،
            و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای
            زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و
            متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را برای طراحان
            رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در زبان فارسی ایجاد
            کرد، در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه
            راهکارها، و شرایط سخت تایپ به پایان رسد و زمان مورد نیاز شامل
            حروفچینی دستاوردهای اصلی، و جوابگوی سوالات پیوسته اهل دنیای موجود
            طراحی اساسا مورد استفاده قرار گیرد.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Comments;
